import Vue from 'vue'
import Teleport from 'vue2-teleport'

Vue.component('Teleport', Teleport)
